export default "__VITE_ASSET__0awfwRWx__"